// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Wlrl","col":"styles_col__3-SZ2","actions":"styles_actions__3KenM","conflict":"styles_conflict__3fGW2"};